export default __webpack_public_path__ + "static/media/eng.195a28f9.png";